import React from 'react';
import { View, Text, StyleSheet, Platform, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { adminTheme, getColor, getSpacing, getBorderRadius, getShadow } from '../../theme/adminTheme';

const QuickActions = ({ navigation }) => {
    const actions = [
        {
            id: 1,
            title: 'Add Participant',
            icon: 'person-add',
            color: 'primary',
            route: 'ParticipantAdd',
        },
        {
            id: 2,
            title: 'Add Inspiration',
            icon: 'bulb',
            color: 'warning',
            route: 'InspirationAdd',
        },
        {
            id: 3,
            title: 'View Participants',
            icon: 'people',
            color: 'success',
            route: 'Participants',
        },
        {
            id: 4,
            title: 'Manage Content',
            icon: 'document-text',
            color: 'primary',
            route: 'InspirationsManage',
        },
        {
            id: 5,
            title: 'Manage Mentors',
            icon: 'school',
            color: 'success',
            route: 'MentorManagement',
        },
        {
            id: 8,
            title: 'Manage Events',
            icon: 'calendar',
            color: 'secondary',
            route: 'EventsManage',
        },
        {
            id: 6,
            title: 'Financial Management',
            icon: 'card',
            color: 'primary',
            route: 'FinancialManagement',
        },
        {
            id: 7,
            title: 'User Feedback',
            icon: 'chatbubble-ellipses',
            color: 'warning',
            route: 'FeedbackManagement',
        },
        {
            id: 9,
            title: 'Mb\'s Honey Pot',
            icon: 'game-controller',
            color: 'warning',
            route: 'HoneyPot',
        },
        {
            id: 10,
            title: 'LMS Progress Tracking',
            icon: 'analytics',
            color: 'primary',
            route: 'LMSProgressTracking',
        },
    ];

    const handleActionPress = (route) => {
        if (navigation && route) {
            navigation.navigate(route);
        }
    };

    return (
        <View style={[styles.container, getShadow('md')]}>
            <View style={styles.header}>
                <Text style={styles.title}>Quick Actions</Text>
                <Text style={styles.subtitle}>Common tasks and shortcuts</Text>
            </View>

            <View style={styles.actionsGrid}>
                {actions.map((action) => (
                    <TouchableOpacity
                        key={action.id}
                        style={[
                            styles.actionCard,
                            { borderLeftColor: getColor(`${action.color}.500`) }
                        ]}
                        onPress={() => handleActionPress(action.route)}
                        activeOpacity={0.7}
                    >
                        <View style={[
                            styles.iconContainer,
                            { backgroundColor: getColor(`${action.color}.50`) }
                        ]}>
                            <Ionicons
                                name={action.icon}
                                size={24}
                                color={getColor(`${action.color}.600`)}
                            />
                        </View>
                        <View style={styles.actionContent}>
                            <Text style={styles.actionTitle}>{action.title}</Text>
                            <Ionicons
                                name="chevron-forward"
                                size={16}
                                color={getColor('gray.400')}
                            />
                        </View>
                    </TouchableOpacity>
                ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#FFFFFF',
        borderRadius: getBorderRadius('lg'),
        padding: getSpacing('lg'),
        marginBottom: getSpacing('lg'),
    },
    header: {
        marginBottom: getSpacing('lg'),
    },
    title: {
        fontSize: 18,
        fontWeight: '600',
        color: getColor('gray.900'),
        marginBottom: 4,
        ...(Platform.OS === 'web' ? { fontFamily: 'Inter, sans-serif' } : {}),
    },
    subtitle: {
        fontSize: 14,
        color: getColor('gray.500'),
        ...(Platform.OS === 'web' ? { fontFamily: 'Inter, sans-serif' } : {}),
    },
    actionsGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginHorizontal: -getSpacing('sm'),
    },
    actionCard: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: getColor('gray.50'),
        borderRadius: getBorderRadius('md'),
        padding: getSpacing('md'),
        marginHorizontal: getSpacing('sm'),
        marginBottom: getSpacing('sm'),
        borderLeftWidth: 3,
        flex: 1,
        minWidth: 280,
        ...(Platform.OS === 'web' ? {
            transition: 'all 0.2s ease',
            cursor: 'pointer',
            ':hover': {
                backgroundColor: '#FFFFFF',
                transform: 'translateX(4px)',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            },
        } : {}),
    },
    iconContainer: {
        width: 48,
        height: 48,
        borderRadius: getBorderRadius('md'),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: getSpacing('md'),
    },
    actionContent: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    actionTitle: {
        fontSize: 14,
        fontWeight: '500',
        color: getColor('gray.700'),
        ...(Platform.OS === 'web' ? { fontFamily: 'Inter, sans-serif' } : {}),
    },
});

export default QuickActions;
